import { UsersThree } from "@phosphor-icons/react";
import { CopyBtn } from "./CopyBtn";

export const META_AUDIENCE = {
  name: "FreightPilot · New-authority carriers (US, mobile, no AN)",
  location: "United States (people living in this location)",
  age: "25 – 60",
  gender: "All",
  language: "English (All)",
  interests: [
    "Truck driver", "Owner-operator", "Trucking industry", "Commercial driver's license", "Freight transport",
    "Semi-trailer truck", "Freightliner Trucks", "Peterbilt", "Kenworth", "Owner-Operator Independent Drivers Association (OOIDA)",
    "Truck stop", "Pilot Flying J", "Load board", "Dispatcher (trucking)", "Logistics",
  ],
  narrow: ["Small business owners", "Engaged shoppers"],
  exclude: ["Website visitors who reached /app (customers)", "People who clicked but bounced (optional once the pixel has data)"],
  placements: {
    on: ["Facebook Feed", "Instagram Feed", "Facebook Reels", "Instagram Reels", "Facebook Stories", "Instagram Stories", "Facebook Marketplace"],
    off: ["Audience Network (all)", "Messenger", "Facebook Right column", "Instagram Explore", "In-stream video"],
  },
  devices: "Mobile only (truckers are on their phones) · iOS + Android · exclude desktop until you have 10+ signups",
  advantage: "Turn OFF Advantage+ audience and Advantage+ placements for the first 2 weeks so Meta can't widen to junk traffic",
  budget: "$15–20/day on ONE campaign · 1 ad set · 2 ads (9:16 video for Reels/Stories, 1:1 for feed) · run 5 days before judging",
  optimize: "Objective Sales → Conversion event StartTrial (fallback: CompleteRegistration) · Landing: freightpilotai.ai/start?utm_source=fb&utm_medium=paid&utm_campaign=signup (signup form → Stripe card page, no plan picking)",
};

export function audienceText() {
  const a = META_AUDIENCE;
  return [
    `AUDIENCE: ${a.name}`,
    `Location: ${a.location}`, `Age: ${a.age} · Gender: ${a.gender} · Language: ${a.language}`,
    "", "Detailed targeting — INCLUDE (search each, tick what Meta offers):", ...a.interests.map((i) => `  • ${i}`),
    "", "Narrow further by (AND) — optional:", ...a.narrow.map((i) => `  • ${i}`),
    "", "EXCLUDE:", ...a.exclude.map((i) => `  • ${i}`),
    "", "PLACEMENTS — Manual:", "  ON:  " + a.placements.on.join(", "), "  OFF: " + a.placements.off.join(", "),
    `Devices: ${a.devices}`, "", a.advantage, a.budget, a.optimize,
  ].join("\n");
}

export default function MetaAudienceCard() {
  const a = META_AUDIENCE;
  return (
    <div className="mt-4 rounded-lg border border-emerald-500/20 bg-emerald-500/[0.04] p-4" data-testid="meta-audience-card">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
        <div className="flex items-center gap-1.5 text-sm font-semibold text-white"><UsersThree size={15} className="text-emerald-400" /> Meta audience preset · truckers, US only, no Audience Network</div>
        <CopyBtn text={audienceText()} label="Copy full setup" testid="meta-audience-copy-all" />
      </div>
      <p className="text-[11px] text-neutral-500 mb-3">Paste into Ads Manager → Ad set. In "Detailed targeting", search each interest and tick the ones Meta shows (names vary slightly). Then Placements → Manual → untick everything in the OFF list.</p>
      <div className="grid sm:grid-cols-2 gap-3 text-xs">
        <div>
          <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-1">Who</div>
          <div className="text-neutral-300">{a.location} · {a.age} · {a.gender}</div>
          <div className="mt-2 flex flex-wrap gap-1" data-testid="meta-audience-interests">
            {a.interests.map((i) => <span key={i} className="rounded-full border border-white/10 bg-white/[0.03] px-2 py-0.5 text-[11px] text-neutral-200">{i}</span>)}
          </div>
          <div className="mt-2"><CopyBtn text={a.interests.join("\n")} label="Copy interests" testid="meta-audience-copy-interests" /></div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-widest text-neutral-500 mb-1">Placements</div>
          <div className="text-emerald-200">ON: {a.placements.on.join(" · ")}</div>
          <div className="text-red-200 mt-1">OFF: {a.placements.off.join(" · ")}</div>
          <div className="text-neutral-400 mt-2">{a.devices}</div>
          <div className="text-neutral-400 mt-1">{a.advantage}</div>
          <div className="text-neutral-400 mt-1">{a.budget}</div>
          <div className="text-neutral-400 mt-1">{a.optimize}</div>
        </div>
      </div>
    </div>
  );
}
